import type { FaireProductEntity } from "../../entity_types/product";

export const p_awkbgvry7b: FaireProductEntity = {
  token: "p_awkbgvry7b",
  type: "product",
  name: "Keychains !",
  brandName: "Tiny Made",
  imageUrl:
    "https://cdn.faire.com/fastly/547f6fb75a1283a82e5692da4f518788b5ff22c4f03ccc211b3963d4346e2b2f.jpeg",
  priceDollars: 6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/1e88eb69b1bb7635e453e9d86b2f74ebb8fe1c0959656383b8759f0d8ef62ad0.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
